export default __webpack_public_path__ + "static/media/misc-closet2-2048w.850b704b.webp";